import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { StytchB2B, StytchEventType } from '@stytch/react/b2b';
import { useMemo } from 'react';
import { FlowCompletingCover } from '@/auth/FlowCompletingCover';
import { buildB2BDiscoveryConfig } from '@/auth/b2bDiscovery';
import { isDemoMode } from '@/lib/demoMode';
import { goToNextOrHome, validateNextSearch } from '@/lib/nextPath';

function AuthenticateRoute() {
  const navigate = useNavigate();
  const { next } = Route.useSearch();
  const b2bConfig = useMemo(
    () => buildB2BDiscoveryConfig(window.location.origin, next),
    [next],
  );

  return (
    <FlowCompletingCover className="flex min-h-screen items-center justify-center bg-background p-4">
      <StytchB2B
        config={b2bConfig}
        callbacks={{
          onEvent: (event) => {
            if (event.type === StytchEventType.AuthenticateFlowComplete) {
              void goToNextOrHome(navigate, next);
            }
          },
        }}
      />
    </FlowCompletingCover>
  );
}

export const Route = createFileRoute('/authenticate')({
  validateSearch: validateNextSearch,
  // Demo has no runtime auth provider; bounce home before mounting component.
  beforeLoad: () => {
    if (isDemoMode()) throw redirect({ to: '/' });
  },
  component: AuthenticateRoute,
});
